var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-popover",
        {
          attrs: {
            target: _vm.targetId,
            triggers: "click blur",
            placement: "top"
          }
        },
        [
          _c("h3", { staticClass: "popover-header" }, [
            _vm._v(_vm._s(_vm.$t("shareInSocialMedia")) + "\r\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "popover-article" },
            [
              _vm._l(_vm.socialNetworks.networks, function(socialNetwork) {
                return _c(
                  "ShareNetwork",
                  {
                    key: socialNetwork.network,
                    style: { "background-Color": socialNetwork.color },
                    attrs: {
                      network: socialNetwork.network,
                      url: _vm.url,
                      title: _vm.socialNetworks.sharing.title,
                      description: _vm.socialNetworks.sharing.description,
                      quote: _vm.socialNetworks.sharing.quote,
                      hashtags: _vm.socialNetworks.sharing.hashtags,
                      twitterUser: _vm.socialNetworks.sharing.twitterUser
                    }
                  },
                  [
                    _c("b-icon", {
                      attrs: { "font-scale": "1.5", icon: socialNetwork.icon }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(socialNetwork.name))])
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "share-network-link",
                  staticStyle: { "background-color": "#4a76a8" },
                  on: {
                    click: function($event) {
                      return _vm.copyLinkClipboard(_vm.url)
                    }
                  }
                },
                [
                  _c("b-icon", {
                    attrs: { "font-scale": "1.5", icon: "share" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("link")))])
                ],
                1
              )
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-655d6103", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655d6103","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/SocialSharingPopover.vue
// module id = 1726
// module chunks = 117